import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Form from "../../form-components/from";
import CategoryContext from "../../../context/category/context";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";
import { useLocation } from "react-router-dom";

interface IProps { }

const CategoryFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query, allCategories } = useContext(CategoryContext);
  const [mainCat, setMainCat] = useState<number>();
  const location = useLocation();
  const [initialValues, setInitialValues] = useState<Record<string, any>>({});

  useEffect(() => {
    const filters = getFiltersFromURL();

    const initialValuesObj = {};
    filters.forEach((f) => {
      initialValuesObj[f.name] = f.value;
    });

    setInitialValues(initialValuesObj);
  }, [location.search]);

  useEffect(() => { !allCategories && actions.getAllData() }, [])
  return (
    <Form
      formId="category-filter"
      defaultValues={initialValues}
      onSubmit={(data) => {
        const keyword = getKeywordFromURL();
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: keyword,
          filters: [
            data?.parentId
              ? {
                name: "parentId",
                value: data.parentId,
                operation: "eq",
              }
              : undefined,
            data?.grandId
              ? {
                name: "grandId",
                value: data.grandId,
                operation: "eq",
              }
              : undefined,

            data?.child
              ? {
                name: "child",
                value: data.child,
                operation: "eq",
              }
              : undefined,
          ].filter((f) => f),
        };

        const queryString = filtersToQueryString(filter.filters);
        window.history.replaceState(null, "", `?${queryString}`);
        addSearchToURL(keyword);
        actions.setQuery(filter);

      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="grandId"
            label={`${t("main_category")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,

              options: allCategories
                ?.filter((cat) => cat?.parent === null && cat?.grand === null)
                .map((grand, index) => {
                  return {
                    type: "select",
                    label: grand?.name as string,
                    value: grand?.id as number,
                  };
                }),
              onChange: (val) => {
                // alert(val);
                setMainCat(val);
              },
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="parentId"
            label={`${t("parent_category")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,

              options: allCategories
                ?.filter((cat) =>
                  mainCat
                    ? cat?.parent === null && cat?.grand?.id == mainCat
                    : !cat?.parent && cat?.grand
                )
                .map((grand, index) => {
                  return {
                    type: "select",
                    label: grand?.name as string,
                    value: grand?.id as number,
                  };
                }),
            }}
          />
        </Col>
        {/* <Col span={8}>
          <FieldBuilder
            name="child"
            label={`${t("child_category")}`}
            width="large"
            input={{
              type: "select",
              options: [1, 2].map((val, index) => {
                return {
                  type: "select",
                  label: val == 1 ? "true" : "false",
                  value: val == 1 ? true : false,
                };
              }),
            }}
          />
        </Col> */}
        {/* <Col span={8}>
          <FieldBuilder
            name="parentId"
            label={`${t("parent_category")}`}
            width="large"
            input={{
              type: "select",
              loading: categoriesLoading,
              options: categories.map((city, index) => {
                return {
                  type: "select",
                  label: city?.name as string,
                  value: city?.id as number,
                };
              }),
            }}
          />
        </Col> */}
      </Row>
    </Form>
  );
};

export default CategoryFilter;
